// extracted by mini-css-extract-plugin
export default {"main":"HomeScreen_main__Rzn9p","greetingMessage":"HomeScreen_greetingMessage__s-NsP"};